import { colors2 } from "oolib";

// Configuration for line chart UI elements
export const _base_linechart_ui_configs = {
  // Margins
  marginTop: 20,
  marginRight: 30,
  marginBottom: 10,
  marginLeft: 0,

  // Line configuration
  lineStrokeWidth: 2,
  lineHoverStrokeWidth: 3,
  lineHitAreaWidth: 15, // Invisible wider stroke for easier hover detection
  lineTransitionDuration: "0.2s",
  lineActiveDot: {
    // Active (hover) dot styling. `r` controls the dot size (radius in px).
    r: 5,
    strokeWidth: 1,
    stroke: colors2.white,
  },

  // Chart dimensions
  defaultHeight: "100%" as number | string, // Default height - fills available space
  minHeight: 500, // Minimum height to prevent chart from becoming too small
  
  // Grid configuration
  grid: {
    vertical: false,
    horizontal: true,
    strokeDasharray: "0",
    stroke: colors2.grey5,
  },
  
  // Axis configuration
  xAxis: {
    tickLine: false,
    axisLine: true,
    axisLineStroke: colors2.grey20,
    tickFill: colors2.grey50,
    // Give the last tick label breathing room so it doesn't get pushed/overlap near the right edge.
    padding: { left: 0, right: 20 }, //  this will only look good when there is no vertical grid enabled
  },
  yAxis: {
    tickLine: false,
    axisLine: true,
    axisLineStroke: colors2.grey20,
    tickFill: colors2.grey50,
    padding: { top: 0, bottom: 0 },
    width: 50, // Width allocated for Y-axis labels
  },
  
  // Grid density (number of grid lines)
  gridDensity: {
    x: 6, // approximate number of vertical grid lines
    y: 5,  // approximate number of horizontal grid lines
  },
};

// hover behaviour - dot to the closest 